/**
 * Created by josefjurca on 4/5/2018.
 */

import _ from 'lodash';


/**
 * Prepares read parameters.
 *
 * @param {string} configURL - ConfigURL.
 * @returns {Object} Read parameters.
 */
export function convertForRead (configURL) {
    return {
        url: configURL
    };
}


/**
 * Converts faq data.
 *
 * @param {Object} faqData - Response data.
 * @returns {Object} Converted faq data.
 */
function convertFAQ (faqData) {
    return {
        q: faqData.question || '',
        a: faqData.answer || ''
    };
}



/**
 * Converts section.
 *
 * @param {Object} section - Response data.
 * @returns {Object} Converted section data.
 */
function convertSection (section) {
    let {images} = section;

    return {
        title: section.title || '',
        images: {
            regular: images.regular,
            mobile: images.mobile
        }
    };
}

/**
 * Converts LP data.
 *
 * @param {Object} lp - Response data.
 * @returns {Object} Converted landing page data.
 */
function convertLP (lp) {
    return {
        type: lp.type || 'general',
        images: lp.images || {},
        title: lp.title || '',
        description: lp.description || '',
        startTime: lp.startTime || null,
        endTime: lp.endTime || null,
        assetId: lp.assetId || null,
        assetReferenceType : lp.isLinear ? 'Epg_internal' : 'Media'
    };
}

/**
 * Converts register section data.
 *
 * @param {Object} registerSection - Register section.
 * @return {{text: string, link: string}} Converted section data.
 */
function convertRegisterSection (registerSection) {
    return {
        text: registerSection.text || '',
        link: registerSection.link || '/register'
    };
}

/**
 * Converts read data to application data.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Converted read data.
 */
export function convertFromRead (response = {}) {

    return {
        notMeText: response.notMeText || '',
        callToAction: convertRegisterSection(response.callToAction || {}),
        register: convertRegisterSection(response.register || {}),
        belowRegisterAnonymous: convertRegisterSection(response.belowRegisterAnonymous || {}),
        collage: convertSection(response.collage),
        devices: convertSection(response.devices),
        faq: {
            title: _.get(response, ['faq', 'title']) || '',
            items: _.map(_.get(response, ['faq', 'items']) || [], data => {
                return convertFAQ(data);
            }),
            button: convertRegisterSection(_.get(response, ['faq', 'button']) || {})
        },
        landingPages: _.map(response.landingPages || [], lp => {
            return convertLP(lp);
        })
    };
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/landingpage.js